import classNames from 'classnames';
import React from 'react';

// Define the props for ElementContainer
interface ElementContainerProps {
    children: React.ReactNode;
    onMouseOver?: React.MouseEventHandler<HTMLDivElement>;
    onMouseOut?: React.MouseEventHandler<HTMLDivElement>;
    onMouseMove?: React.MouseEventHandler<HTMLDivElement>;
    fullWidth?: boolean;
}

const ElementContainer = React.forwardRef<HTMLDivElement, ElementContainerProps>(
    ({ children, onMouseOver, onMouseOut, onMouseMove, fullWidth }, ref) => {
        return (
            <div ref={ref} className="w-full flex justify-center group">
                <div
                    className={classNames('select-text border-transparent w-full relative', {
                        'max-w-700': !fullWidth,
                    })}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onMouseMove={onMouseMove}
                >
                    {children}
                </div>
            </div>
        );
    },
);

ElementContainer.displayName = 'ElementContainer';

export default ElementContainer;
